<template>
  <div>
    <div class="loading" v-if="loading">
      <Circle-Loader :size="36" class="mt-3"></Circle-Loader>
    </div>
    <div class="loading" v-if="!loading">
      <div
        class="checklist-wrapper"
        v-show="order.workflow[workflow].checklist.length"
      >
        <TaskChecklist
          :order="order"
          workflow="permitting"
          :hide-detail="hideAddButton"
        ></TaskChecklist>
        <b-button
          v-if="!hideAddButton"
          variant="success"
          @click="$bvModal.show('confirmAddRevision')"
          size="sm"
          class="mt-2"
          >+ Add Permit Revision</b-button
        >
        <b-modal
          hide-footer
          id="confirmAddRevision"
          title="Add Permit Revision"
        >
          Add permit revision to checklist?

          <div class="modal-ctas mt-4">
            <b-button
              variant="primary"
              @click="addPermitRevision"
              :disabled="savingChecklist"
            >
              <span v-if="savingChecklist">Confirming..</span>
              <span v-if="!savingChecklist">Confirm</span>
            </b-button>
            <b-button
              variant="secondary"
              @click="$bvModal.hide('confirmAddRevision')"
              :disabled="savingChecklist"
              class="ml-2"
              >Cancel</b-button
            >
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'
import { permittingChecklist } from '../data/checklistDefaults'
import TaskChecklist from '@/components/TaskChecklist'

export default {
  name: 'PermittingChecklist',
  props: {
    order: {
      type: Object,
      required: true,
    },
    hideAddButton: {
      type: Boolean,
      default: false,
    },
  },
  inject: ['userStore'],
  components: { TaskChecklist },
  data: function () {
    return {
      workflow: 'permitting',
      savingChecklist: false,
      submitting: false,
      loading: true,
    }
  },
  methods: {
    async addPermitRevision() {
      let revNum = 1
      let lastItem = _.last(this.order.workflow[this.workflow].checklist)
      let lastRevNum = lastItem.task.match(/\d+/)
      if (lastRevNum) {
        revNum = parseInt(lastRevNum[0]) + 1
      }
      this.order.workflow[this.workflow].checklist.push({
        task: `Permit Revision Required (${revNum})`,
        done: false,
        timestamp: null,
        user: '',
        notes: [],
      })
      this.order.workflow[this.workflow].checklist.push({
        task: `Permit Resubmitted (${revNum})`,
        done: false,
        timestamp: null,
        user: '',
        notes: [],
      })
      await this.saveChecklist(this.order.workflow[this.workflow].checklist)
      this.$bvModal.hide('confirmAddRevision')
      this.$toasted.success(`Added revision to checklist`, {
        duration: 2500,
      })
    },
    saveChecklist(checklist) {
      const data = {
        id: this.order.id,
        workflow: this.workflow,
        checklist,
      }
      this.savingChecklist = true
      return axios
        .put('/services/orders/save-checklist', data)
        .then(response => {
          console.log('response.data.checklist: ', response.data.checklist)
        })
        .catch(error => {
          this.$toasted.error(` Error adding to checklist`, {
            action: {
              text: 'Close',
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
              },
            },
          })
        })
        .finally(() => {
          this.savingChecklist = false
          this.loading = false
        })
    },
  },
  mounted() {
    // this.saveChecklist([]) // resets while deving locally
    // set default checklists
    if (!this.order.workflow.permitting.checklist.length) {
      window.setTimeout(() => {
        this.order.workflow.permitting.checklist = permittingChecklist.map(
          item => {
            return {
              task: item,
              done: false,
              timestamp: null,
              user: '',
              notes: [],
            }
          },
        )
        this.saveChecklist(this.order.workflow.permitting.checklist)
      }, 2000)
    } else {
      this.loading = false
    }
  },
}
</script>

<style scoped lang="scss">
@import '../styles/variables';
.status-display {
  font-size: 20px;
}
.hold-reason {
  font-size: 16px;
}
.status {
  font-weight: bold;
}
.open {
  color: $open-color;
}
.in-progress {
  color: $in-progress-color;
}
.on-hold {
  color: $on-hold-color;
}
.cancelled {
  color: $cancelled-color;
}
.ready {
  color: $ready-color;
}
.completed {
  color: $completed-color;
}
</style>
